<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            v-if="$route.name === 'betterdoc'"
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text="">
          </back-button>
          <ion-button v-else @click="modalController.dismiss()">
            <ion-icon
              :src="require('@lib/assets/icons/icon_zurueck.svg')"
              slot="start"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <ion-grid fixed>
        <erklaerung-better-doc :from="from" @openChat="openChat('betterDoc')" />
        <!-- <div class="ion-margin-top">
          <img src="@arag/assets/img/betterdoc_logo.svg" />
        </div> -->
        <ion-row
          class="ion-align-items-center ion-margin-top"
          v-if="!['contact', 'chat'].includes(from)">
          <ion-col>
            <div class="c-cta">
              <ion-button
                v-if="from === 'secondopinion'"
                @click="openChat('betterDoc')"
                class="mt-5"
                >Jetzt Zweitmeinung einholen&nbsp;
                <ion-icon
                  :src="require('@lib/assets/icons/roodie-white.svg')"
                  slot="end"></ion-icon>
              </ion-button>
              <ion-button v-else @click="openChat('betterDoc')" class="mt-5"
                >Jetzt Facharzt/Klinik suchen&nbsp;
                <ion-icon
                  :src="require('@lib/assets/icons/roodie-white.svg')"
                  slot="end"></ion-icon>
              </ion-button>
            </div>
          </ion-col>
          <!-- <ion-col class="ion-text-right">
            <img src="@arag/assets/img/betterdoc_logo.svg" width="130" />
          </ion-col> -->
        </ion-row>
        <!-- <div class="c-iframe ion-margin-top">
          <div class="c-iframe__wrapper">
            <iframe
              class="c-iframe__video"
              width="560"
              height="315"
              src="https://player.vimeo.com/video/585315896?h=976c9478d7&title=0&byline=0&portrait=0"
              title="Vimeo video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div> -->
        <ion-row
          class="ion-margin-top"
          v-if="!['contact', 'chat'].includes(from)">
          <ion-col>
            <div
              class="c-nugget u-bg-blue"
              @click="$router.push({ path: '/betterdoc/anleitung' })">
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/icon_roodie_call.svg') +
                    ')',
                }"></div>
              <div class="c-nugget__label">So funktioniert's</div>
            </div>
          </ion-col>
          <ion-col>
            <div class="c-nugget u-bg-blue" @click="showVideoModal = true">
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/home/icon_roodie_video.svg') +
                    ')',
                }">
                <img src="@/assets/img/play.svg" />
              </div>
              <div class="c-nugget__label">Video zu BetterDoc</div>
            </div>
          </ion-col>
        </ion-row>
        <div
          class="c-nugget -no-pointer -cover u-bold ion-margin-top"
          :style="{
            'background-image':
              'url(' + require('@/assets/img/gradient_blau.svg') + ')',
          }"
          v-if="!['contact', 'chat'].includes(from)">
          <div class="c-nugget__content">
            <div class="ion-padding-bottom">
              Ich brauche Unterstützung bei der Arzt- oder Kliniksuche.*
            </div>
            <div class="c-nugget__buttons ion-margin-top">
              <ion-button
                @click="
                  $router.push({
                    name: 'betterdoc-kontakt',
                    params: { from: from },
                  })
                "
                class="u-small"
                color="light">
                <ion-icon
                  :src="require('@lib/assets/icons/icon_dok.svg')"
                  slot="start" />
                Anfrage starten</ion-button
              >
            </div>
          </div>
          <div class="u-small ion-margin-bottom">
            *Ausführender Partner:
            <a
              href="#"
              class="u-color-white"
              @click.prevent="
                $router.push({
                  name: 'betterdoc',
                })
              "
              >BetterDoc GmbH</a
            >
          </div>
        </div>
        <!-- <div
          class="c-nugget -no-pointer ion-margin-top"
          :style="{
            'background-image':
              'url(' + require('@/assets/img/gradient_lila.svg') + ')',
          }"
        >
          <div class="c-nugget__content">
            <div class="ion-padding-bottom">
              Ich möchte jetzt gleich ein Arztgespräch führen.
            </div>
            <div class="c-nugget__buttons ion-margin-top">
              <ion-button
                @click="
                  $router.push({
                    name: 'datenschutz',
                    params: { routing: 'BetterDoc' },
                  })
                "
                class="u-small"
                fill="outline"
                color="light"
                ><ion-icon :icon="people" slot="start"></ion-icon>Persönliche
                Beratung</ion-button
              >
              <ion-button
                @click="
                  $router.push({
                    name: 'datenschutz',
                    params: {
                      routing: 'BetterDoc',
                      link: 'https://www.betterdoc.org/arag#anfrage-starten',
                    },
                  })
                "
                class="u-small"
                fill="outline"
                color="light"
                ><ion-icon :icon="call" slot="start"></ion-icon>Rückruf
                buchen</ion-button
              >
            </div>
          </div>
        </div> -->
        <!-- <ion-row class="ion-margin-top">
          <ion-col size="auto">
            <ion-icon :src="require('@lib/assets/icons/info.svg')" />
          </ion-col>
          <ion-col>
            <ion-text color="primary" class="u-xsmall">
              Das Angebot von BetterDoc ist eine Zusatzleistung des
              Kooperationspartners.
              Sie kann jederzeit entfallen, wenn die Kooperation endet.
            </ion-text>
          </ion-col>
        </ion-row> -->
      </ion-grid>
    </ion-content>
    <ion-modal
      :is-open="showVideoModal"
      :css-class="['c-autoheight-modal']"
      @didPresent="playVideo"
      @didDismiss="showVideoModal = false">
      <ion-page>
        <div class="modal-content">
          <modal-close />
          <div class="c-iframe" style="margin-top: 43px">
            <div class="c-iframe__wrapper">
              <iframe
                id="video"
                class="c-iframe__video"
                width="560"
                height="315"
                src="https://player.vimeo.com/video/585315896"
                title="Vimeo video player"
                frameborder="0"
                allow="autoplay"
                allowfullscreen
                webkitallowfullscreen
                mozallowfullscreen></iframe>
            </div>
          </div>
        </div>
      </ion-page>
    </ion-modal>
  </ion-page>
</template>

<script>
import { chevronBack, call, people } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  IonRow,
  IonCol,
  // IonText,
  IonModal,
  IonBackButton,
  modalController,
} from "@ionic/vue";
import ErklaerungBetterDoc from "@/components/ErklaerungBetterDoc";
// import Roodie from "@lib/components/svg/Roodie";
import ModalClose from "@lib/components/ModalClose";
import Player from "@vimeo/player";
// import KostenerstattungModal from "@arag/components/KostenerstattungBetterDocModal";
import { chat } from "@/mixins/chat";

export default {
  mixins: [chat],
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    IonRow,
    IonCol,
    ErklaerungBetterDoc,
    // IonText,
    IonModal,
    ModalClose,
    IonBackButton,
    // Roodie,
  },
  props: {
    from: {
      type: String,
      required: false,
      default: "contact",
    },
  },
  data() {
    return {
      showVideoModal: false,
      modalController: modalController,
    };
  },
  methods: {
    // async openKostenerstattungModal() {
    //   const modal = await modalController.create({
    //     component: KostenerstattungModal,
    //   });
    //   return modal.present();
    // },
    playVideo() {
      const iframe = document.getElementById("video");
      const player = new Player(iframe);

      // player.setColor("#5e58be");

      player.on("play", (response) => {
        if (response.seconds === 0) {
          if (player.requestFullscreen) {
            player.requestFullscreen();
          } else if (player.webkitRequestFullscreen) {
            /* Safari */
            player.webkitRequestFullscreen();
          } else if (player.msRequestFullscreen) {
            /* IE11 */
            player.msRequestFullscreen();
          }
        }
      });

      player.play();
    },
  },
  setup() {
    return {
      chevronBack,
      call,
      people,
    };
  },
};
</script>

<style lang="scss" scoped></style>
